import classNames from 'classnames'

import styles from './body.module.sass'

function Body(props) {
	return <div className={classNames(styles.body_content_container)}>{props.children}</div>
}

export default Body